import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TPcg from './Tables/TPcg';
const Pcg: React.FC = () => {
    return (
        <div>
            <AdminHeader>PCG</AdminHeader>  
            <TPcg/>        
        </div>

    );
};


export default Pcg;